<template>
  <div class="payroll__setting">
    <div>
      <div class="payroll__setting--left">
        <span
          >What Day of The Month Do You Want To Run Payroll For this
          Company?</span
        >
        <div class="payroll__setting--date">
          <div class="payroll__setting--date-left">
            <select v-model="selectedDate">
              <option v-for="date in days" :key="date" :value="date">
                {{ date }}
              </option>
            </select>
          </div>
          <div class="payroll__setting--date-right">
            <font-awesome-icon icon="calendar" />&nbsp;Next Payroll Run Date
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="payroll__setting--left">
        <p>Compensation:</p>
        <div class="payroll__setting--left-text">
          Some default has been selected but you can delete the ones you don't
          need.
        </div>
        <div class="payroll__setting--left-text">
          Click
          <a href="./demo" target="_blank">here</a> to see a preview of a demo
          payroll
        </div>
        <div class="payroll__setting--left-section">
          <div v-for="(one, index) in compensation" v-bind:key="one.index">
            <div>
              <div class="payroll__setting--left-section-name">
                {{ one.name }}
              </div>
              <div
                class="payroll__setting--left-section-close"
                @click="removeItem(index, compensation)"
                v-if="
                  one.name !== 'Basic' &&
                  one.name !== 'Housing' &&
                  one.name !== 'Reimbursement' &&
                  one.name !== 'Tax' &&
                  one.name !== 'Pension'
                "
              >
                <font-awesome-icon icon="times-circle" />
              </div>
            </div>
          </div>
        </div>
        <div class="payroll__setting--left-alert">
          <font-awesome-icon icon="bullhorn" />&nbsp;Funfact: when you type,
          click enter and what you typed will appear above like the other ones
        </div>
        <div class="payroll__setting--left-input">
          <input
            type="text"
            v-model="compensationValue"
            placeholder="Type here to add more..."
            @keyup.enter="addCompensation"
          />
        </div>
      </div>
      <div class="payroll__setting--right">
        <p>Selected Compensation</p>
        <ul>
          <li v-for="one in compensation" v-bind:key="one.index">
            {{ one.name }}
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div class="payroll__setting--left">
        <p>Deductibles:</p>
        <div class="payroll__setting--left-text">
          Some default has been selected but you can delete the ones you don't
          need.
        </div>
        <div class="payroll__setting--left-text">
          Click
          <a href="./demo" target="_blank">here</a> to see a preview of a demo
          payroll
        </div>
        <div class="payroll__setting--left-section">
          <div v-for="(two, index) in deductibles" v-bind:key="two.index">
            <div>
              <div class="payroll__setting--left-section-name">
                {{ two.name }}
              </div>
              <div
                class="payroll__setting--left-section-close"
                @click="removeItem(index, deductibles)"
                v-if="
                  two.name !== 'Basic' &&
                  two.name !== 'Housing' &&
                  two.name !== 'Reimbursement' &&
                  two.name !== 'Tax' &&
                  two.name !== 'Pension'
                "
              >
                <font-awesome-icon icon="times-circle" />
              </div>
            </div>
          </div>
        </div>
        <div class="payroll__setting--left-alert">
          <font-awesome-icon icon="bullhorn" />&nbsp;Funfact: when you type,
          click enter and what you typed will appear above like the other ones
        </div>
        <div class="payroll__setting--left-input">
          <input
            type="text"
            v-model="deductiblesValue"
            placeholder="Type here to add more..."
            @keyup.enter="addDeductibles"
          />
        </div>
      </div>
      <div class="payroll__setting--right">
        <p>Selected Deductibles</p>
        <ul>
          <li v-for="two in deductibles" v-bind:key="two.index">
            {{ two.name }}
          </li>
        </ul>
      </div>
    </div>

    <div style="margin-bottom: 10px">
      <div class="payroll__setting--error">
        <p v-show="dateError">Please select a date for the next payment.</p>
        <p v-show="networkError">Please select a date for the next payment.</p>
        <p v-show="successMsg">Payroll setting updated successfully.</p>
      </div>
    </div>
    <div>
      <div class="payroll__setting--btn" @click="sendSetting" v-show="!loader">
        Save Settings
      </div>
      <div class="payroll__setting--loader" v-show="loader">
        <WhiteLoader />
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "PayrollSetting",
  components: {
    WhiteLoader,
  },
  data() {
    return {
      loader: false,
      dateError: false,
      successMsg: false,
      networkError: false,
      days: [],
      selectedDate: 0,
      compensationValue: "",
      deductiblesValue: "",
      payablesValue: "",
      compensation: [],
      deductibles: [],
      payables: [],
    };
  },
  methods: {
    addCompensation() {
      if (this.compensationValue) {
        this.compensation.push({
          name: this.compensationValue,
          type: "Compensation",
        });
        this.compensationValue = "";
      }
    },
    addDeductibles() {
      if (this.deductiblesValue) {
        console.log("Pushed", this.deductiblesValue);
        this.deductibles.push({
          name: this.deductiblesValue,
          type: "Deductible",
        });
        this.deductiblesValue = "";
      }
    },
    addPayables() {
      if (this.payablesValue) {
        this.payables.push({
          name: this.payablesValue,
          type: "Payable",
        });
        this.payablesValue = "";
      }
    },
    removeItem(index, arr) {
      arr.splice(index, 1);
    },
    sendSetting() {
      this.dateError = false;
      this.successMsg = false;
      this.networkError = false;
      const payrollComponent = [];

      if (this.compensation.length !== 0) {
        for (
          let compValue = 0;
          compValue < this.compensation.length;
          compValue++
        ) {
          payrollComponent.push({
            name: this.compensation[compValue].name,
            type: this.compensation[compValue].type,
          });
        }
      }

      if (this.deductibles.length !== 0) {
        for (let dedValue = 0; dedValue < this.deductibles.length; dedValue++) {
          payrollComponent.push({
            name: this.deductibles[dedValue].name,
            type: this.deductibles[dedValue].type,
          });
        }
      }

      if (this.payables.length !== 0) {
        for (let payValue = 0; payValue < this.payables.length; payValue++) {
          payrollComponent.push({
            name: this.payables[payValue].name,
            type: this.payables[payValue].type,
          });
        }
      }

      if (!this.selectedDate) {
        this.dateError = true;
        return;
      }

      let user = this.$store.getters.currentAuthUser;

      this.loader = true;

      const payrollSetting = {
        company_id: user.employees.company_id,
        payroll_month: this.selectedDate,
        payroll_components: payrollComponent,
      };

      this.$http
        .post(types.PAYROLL_SETTING_API, payrollSetting)
        .then(() => {
          this.loader = false;
          this.dateError = false;
          this.successMsg = true;
          this.networkError = false;
        })
        .catch(() => {
          this.loader = false;
          this.successMsg = false;
          this.networkError = true;
        });
    },
  },
  created() {
    const now = new Date();
    this.days = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();

    const companyId = this.$store.getters.currentAuthUser.employees.company_id;
    this.$http
      .get(`${types.COMPANY_GET_API}/${companyId}`)
      .then((resp) => {
        this.selectedDate = resp.data.data.payroll_month;
      })
      .catch(() => {});

    this.$http
      .get(types.GET_PAYROLL_COMPONENTS_API)
      .then((resp) => {
        const data = resp.data.data;
        for (let index = 0; index < data.length; index++) {
          if (data[index].type.trim().toLowerCase() === "compensation") {
            this.compensation.push(data[index]);
          }

          if (data[index].type.trim().toLowerCase() === "deductible") {
            this.deductibles.push(data[index]);
          }

          if (data[index].type.trim().toLowerCase() === "payable") {
            this.payables.push(data[index]);
          }
        }
      })
      .catch();
  },
};
</script>

<style lang="scss" scoped>
.payroll__setting {
  padding-top: 56px;
  padding-bottom: 150px;
  overflow: hidden;

  > div {
    overflow: hidden;
    margin-bottom: 40px;
    > .payroll__setting--left {
      width: 41.667rem;
      float: left;

      @media (max-width: 768px) {
        width: 22rem;
      }

      > p {
        font-size: 1.458rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > span {
        font-size: 1.25rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      .payroll__setting--date {
        margin-top: 1.5rem;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        > .payroll__setting--date-left {
          width: 8rem;
          height: 40px;
          border-radius: 2px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;

          > select {
            width: 100%;
            height: 40px;
            font-size: 1.25rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
            border: 0;
            outline: 0;
            padding: 0 25px;
          }
        }

        .payroll__setting--date-right {
          width: calc(100% - 2rem);
          font-size: 0.938rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.22;
          letter-spacing: normal;
          text-align: left;
          color: #777777;
          padding-left: 20px;
        }
      }

      > .payroll__setting--left-text {
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-bottom: 20px;

        > a {
          color: #5099de;
          text-decoration: none;
        }
      }

      > .payroll__setting--left-input {
        height: 40px;
        border: solid 1px #c7c7c7;
        background-color: #ffffff;
        overflow: hidden;

        > input {
          height: 40px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          font-size: 0.833rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.5;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          padding: 10px;
          outline: 0;
          border: 0;
        }
      }

      .payroll__setting--left-alert {
        margin: 10px 0;
        font-size: 0.833rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.33;
        letter-spacing: normal;
        text-align: left;
        color: #f17d6b;
      }

      .payroll__setting--left-section {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        > div {
          width: 25%;
          padding-right: 20px;
          padding-bottom: 10px;

          @media (max-width: 768px) {
            width: 45%;
          }

          > div {
            border-radius: 20px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            height: 46px;
            font-size: 0.833rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.5;
            letter-spacing: normal;
            text-align: left;
            padding: 0 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            align-content: center;
            color: #5099de;

            > .payroll__setting--left-section-name {
              width: 70%;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            > .payroll__setting--left-section-close {
              width: 30%;
              text-align: right;
              cursor: pointer;
            }
          }
        }
      }
    }

    > .payroll__setting--right {
      width: 24.948rem;
      float: right;
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
      background-color: #ffffff;
      padding: 3rem 3rem;

        @media (max-width: 768px) {
            float: none;
            padding: 6rem;
          }

      > p {
        font-size: 1.042rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #5099de;
      }

      > ul {
        padding-left: 20px;

        > li {
          font-size: 0.938rem;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }
    }

    > .payroll__setting--error {
      height: 20px;
      font-style: italic;
      font-size: 0.833rem;
      color: red;
      text-align: left;
    }

    > .payroll__setting--btn {
      width: 9.063rem;
      height: 41px;
      border-radius: 5px;
      background-color: #5099de;
      font-size: 0.781rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;

        @media (max-width: 768px) {
            width: 90%;
            margin: 0 auto;
          }
      
    }

    > .payroll__setting--loader {
      width: 9.063vw;
      height: 41px;
      border-radius: 5px;
      background-color: #5099de;
      font-size: 0.781rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }
  }
}
</style>
